module.exports = __webpack_public_path__ + "static/media/in_progress.0194efae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiendas/roadmap/in_progress.png
// module id = 2188
// module chunks = 0